module.exports = "https://web-assets.ifttt.com/packs/media/settings/control-your-data-8c579a64.svg";